import * as Yup from "yup";

export const BrokerName = Yup.object({
  name: Yup.string().min(1).max(30).required("Broker name is required"),
  abbreviation: Yup.string().min(1).max(100).required("Abbreviation is required"),
  commission: Yup.number().min(0, "Commission must be a positive number"),
});